<script lang="ts">
	import Profile from './Profile.svelte';
	export let params;
	export let getPreviousRoute;

</script>

<Profile {params}
		 {getPreviousRoute}
/>